// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__1ZVYU","screen":"styles_screen__2lZ9l","loader":"styles_loader__3I8Qn","navBar":"styles_navBar__34hG9","content":"styles_content__35vY0"};